export function createTableSettingsDialogPlugin(): any {
    return {
        name: 'tableSettingsDialog',
        display: 'dialog',
        title: "Table and Cell Settings",
        innerHTML: `<div className='header-button'>Table Settings</div>`,
        buttonClass: "header-button-wrapper",

        add: function (core: any) {
            core.addModule(['dialog']);

            const context = core.context as any;
            context.tableSettingsDialog = {
                dropdownSelect: null as HTMLSelectElement | null,
                allCellsAlignSelect: null as HTMLSelectElement | null,
                cellAlignSelect: null as HTMLSelectElement | null,
                tableBorderCheckbox: null as HTMLInputElement | null,
                cellBorderCheckbox: null as HTMLInputElement | null,
                tableWidthInput: null as HTMLInputElement | null,
                cellPaddingInput: null as HTMLInputElement | null,
                activeTab: 'table-settings',
            };

            let dropdown_dialog = this.setDialog(core);
            context.tableSettingsDialog.modal = dropdown_dialog;
            context.tableSettingsDialog.dropdownSelect = dropdown_dialog.querySelector('.se-input-select');
            context.tableSettingsDialog.allCellsAlignSelect = dropdown_dialog.querySelector('.se-all-cells-align-select');
            context.tableSettingsDialog.cellAlignSelect = dropdown_dialog.querySelector('.se-cell-align-select');
            context.tableSettingsDialog.tableBorderCheckbox = dropdown_dialog.querySelector('.se-table-border-toggle');
            context.tableSettingsDialog.cellBorderCheckbox = dropdown_dialog.querySelector('.se-cell-border-toggle');
            context.tableSettingsDialog.tableWidthInput = dropdown_dialog.querySelector('.se-table-width-input');
            context.tableSettingsDialog.cellPaddingInput = dropdown_dialog.querySelector('.se-cell-padding-input');

            const form = dropdown_dialog.querySelector('form.editor_dropdown');
            if (form) {
                form.addEventListener('submit', this.submit.bind(core));
            }
            const tabButtons = dropdown_dialog.querySelectorAll(".se-tab-button");
            tabButtons.forEach((button: any) => {
                button.addEventListener("click", () => {
                    context.tableSettingsDialog.activeTab = button.getAttribute("data-tab");
                    tabButtons.forEach((btn: any) => btn.classList.remove("active"));
                    button.classList.add("active");
                });
            });

            context.dialog.modal.appendChild(dropdown_dialog);
        },

        setDialog: function (core: any): HTMLDivElement {
            const dialog = document.createElement("div");
            dialog.className = "se-dialog-content";
            dialog.style.display = "none";
            dialog.style.position = "absolute";
            dialog.style.width = "500px";
            dialog.style.top = "50px";
            dialog.style.left = "calc(50% - 250px)";

            let html = `
                <form class="editor_dropdown">
                    <div class="se-dialog-header" id="se-dialog-header" style="cursor: move;">
                        <button type="button" data-command="close" class="se-btn se-dialog-close" aria-label="Close">
                            ${core.icons.cancel}
                        </button>
                        <span class="se-modal-title">Table & Cell Settings</span>
                    </div>

                    <!-- Tab Navigation -->
                    <div class="se-dialog-tabs">
                        <button type="button" class="se-tab-button active" data-tab="table-settings">Table Settings</button>
                        <button type="button" class="se-tab-button" data-tab="cell-settings">Cell Settings</button>
                    </div>

                    <div class="se-dialog-body">
                        <!-- Table Settings Tab -->
                        <div class="se-tab-content" id="table-settings">
                            <div class="se-dialog-grid">
                                <div class="se-dialog-form">
                                    <label>Table Width (%)</label>
                                    <input type="number" class="se-table-width-input" min="10" max="100" value="100">
                                </div>

                                <div class="se-dialog-form">
                                    <label>Table Alignment</label>
                                    <select class="se-input-select">
                                        <option value="none">None</option>
                                        <option value="left">Left</option>
                                        <option value="center">Center</option>
                                        <option value="right">Right</option>
                                    </select>
                                </div>
                            </div>

                            <div class="se-dialog-form">
                                <strong>All Table Cells</strong>
                            </div>

                            <div class="se-dialog-grid">
                                <div class="se-dialog-form">
                                    <label>Cell Padding (px)</label>
                                    <input type="number" class="se-cell-padding-input" min="0" max="50" value="5">
                                </div>

                                <div class="se-dialog-form">
                                    <label>Text Alignment</label>
                                    <select class="se-all-cells-align-select">
                                        <option value="top-left">Top Left</option>
                                        <option value="top-center">Top Center</option>
                                        <option value="top-right">Top Right</option>
                                        <option value="middle-left">Center Left</option>
                                        <option value="middle-center">Center</option>
                                        <option value="middle-right">Center Right</option>
                                        <option value="bottom-left">Bottom Left</option>
                                        <option value="bottom-center">Bottom Center</option>
                                        <option value="bottom-right">Bottom Right</option>
                                    </select>
                                </div>

                                <div class="se-checkbox-group">
                                    <label>
                                        <input type="checkbox" class="se-table-border-toggle">
                                        Hide All Borders
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Cell Settings Tab -->
                        <div class="se-tab-content" id="cell-settings" style="display: none;">
                            <div class="se-dialog-grid">
                                <div class="se-dialog-form">
                                    <label>Text Alignment</label>
                                    <select class="se-cell-align-select">
                                        <option value="top-left">Top Left</option>
                                        <option value="top-center">Top Center</option>
                                        <option value="top-right">Top Right</option>
                                        <option value="middle-left">Center Left</option>
                                        <option value="middle-center">Center</option>
                                        <option value="middle-right">Center Right</option>
                                        <option value="bottom-left">Bottom Left</option>
                                        <option value="bottom-center">Bottom Center</option>
                                        <option value="bottom-right">Bottom Right</option>
                                    </select>
                                </div>

                                <div class="se-checkbox-group">
                                    <label>
                                        <input type="checkbox" class="se-cell-border-toggle">
                                        Hide Cell Border
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="se-dialog-footer">
                        <button type="submit" class="se-btn-primary">
                            <span>Apply</span>
                        </button>
                    </div>
                </form>
            `;

            dialog.innerHTML = html;

            const header = dialog.querySelector("#se-dialog-header") as HTMLDivElement;
            let offsetX = 0, offsetY = 0, isDragging = false;

            function onMouseMove(event: MouseEvent) {
                if (isDragging) {
                    const viewportWidth = window.innerWidth;
                    const viewportHeight = window.innerHeight;
                    const dialogWidth = dialog.offsetWidth;
                    const dialogHeight = dialog.offsetHeight;

                    let newX = event.clientX - offsetX;
                    let newY = event.clientY - offsetY;

                    // Prevent moving outside the viewport
                    newX = Math.max(0, Math.min(viewportWidth - dialogWidth, newX));
                    newY = Math.max(0, Math.min(viewportHeight - dialogHeight, newY));

                    dialog.style.left = `${newX}px`;
                    dialog.style.top = `${newY}px`;
                }
            }

            function onMouseUp() {
                isDragging = false;
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            }

            header?.addEventListener("mousedown", function (event) {
                isDragging = true;
                offsetX = event.clientX - dialog.offsetLeft;
                offsetY = event.clientY - dialog.offsetTop;
                dialog.style.zIndex = "9999";

                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
            });

            const tabButtons = dialog.querySelectorAll(".se-tab-button");
            const tabContents = dialog.querySelectorAll(".se-tab-content");

            tabButtons.forEach((button) => {
                button.addEventListener("click", function () {
                    tabButtons.forEach((btn) => btn.classList.remove("active"));
                    button.classList.add("active");

                    tabContents.forEach((content) => {
                        (content as HTMLElement).style.display = "none";
                    });

                    const selectedTab = button.getAttribute("data-tab");
                    const selectedContent = dialog.querySelector(`#${selectedTab}`) as HTMLElement;
                    if (selectedContent) {
                        selectedContent.style.display = "block";
                    }
                });
            });

            return dialog;
        },

        open: function (this: any) {
            const selection = this.getSelection();
            if (!selection || !selection.rangeCount) {
                this.context.tableSettingsDialog.selectedTable = null;
                this.context.tableSettingsDialog.selectedCell = null;
                return;
            }

            const range = selection.getRangeAt(0);
            let selectedNode = range.startContainer as HTMLElement;

            if (selectedNode.nodeType === 3) { // Text node
                selectedNode = selectedNode.parentElement as HTMLElement;
            }

            const cell = selectedNode?.closest('td, th') as HTMLElement;
            const table = cell?.closest('table') as HTMLElement;

            if (table) {
                this.context.tableSettingsDialog.selectedTable = table;

                const tableWidth = table.style.width ? parseInt(table.style.width.replace('%', '')) : 100;
                this.context.tableSettingsDialog.tableWidthInput!.value = tableWidth.toString();

                let alignment = "none";
                if (table.style.marginLeft === '0px' && table.style.marginRight === 'auto') alignment = "left";
                else if (table.style.marginLeft === 'auto' && table.style.marginRight === 'auto') alignment = "center";
                else if (table.style.marginLeft === 'auto' && table.style.marginRight === '0px') alignment = "right";
                this.context.tableSettingsDialog.dropdownSelect!.value = alignment;

                this.context.tableSettingsDialog.tableBorderCheckbox!.checked = table.classList.contains("se-table-no-border");

                const firstCell = table.querySelector("td, th") as HTMLElement;
                const cellPadding = firstCell?.style.padding ? parseInt(firstCell.style.padding.replace('px', '')) : 5;
                this.context.tableSettingsDialog.cellPaddingInput!.value = cellPadding.toString();
            } else {
                this.context.tableSettingsDialog.selectedTable = null;
                this.context.tableSettingsDialog.tableWidthInput!.value = "100";
                this.context.tableSettingsDialog.cellPaddingInput!.value = "5";
                this.context.tableSettingsDialog.dropdownSelect!.value = "none";
                this.context.tableSettingsDialog.tableBorderCheckbox!.checked = false;
            }

            if (cell) {
                this.context.tableSettingsDialog.selectedCell = cell;

                const innerDiv = cell.querySelector("div");
                const allCellsAlignment = innerDiv?.getAttribute('data-align');
                const cellAlignment = innerDiv?.getAttribute('data-cell-align') || allCellsAlignment;
                this.context.tableSettingsDialog.cellAlignSelect!.value = cellAlignment;
                this.context.tableSettingsDialog.allCellsAlignSelect!.value = allCellsAlignment;
                this.context.tableSettingsDialog.cellBorderCheckbox!.checked = cell.classList.contains("se-cell-no-border");
            } else {
                this.context.tableSettingsDialog.selectedCell = null;
                this.context.tableSettingsDialog.allCellsAlignSelect!.value = "top-left";
                this.context.tableSettingsDialog.cellAlignSelect!.value = "top-left";
                this.context.tableSettingsDialog.cellBorderCheckbox!.checked = false;
            }

            this.plugins.dialog.open.call(this, 'tableSettingsDialog');

            setTimeout(() => {
                const firstInput = this.context.tableSettingsDialog.modal?.querySelector("input, select, button") as HTMLElement;
                if (firstInput) {
                    firstInput.focus();
                }
            }, 100);
        },

        submit: function (this: any, e: Event) {
            e.preventDefault();
            e.stopPropagation();
            const contextDropdown = this.context.tableSettingsDialog;
            const selectedTable = contextDropdown.selectedTable;
            const selectedCell = contextDropdown.selectedCell;
            const selectedAlignment = contextDropdown.dropdownSelect?.value;
            const selectedCellsAlignment = contextDropdown.allCellsAlignSelect?.value;
            const selectedCellAlignment = contextDropdown.cellAlignSelect?.value;
            const tableBorderEnabled = contextDropdown.tableBorderCheckbox?.checked;
            const cellBorderEnabled = contextDropdown.cellBorderCheckbox?.checked;
            const tableWidth = contextDropdown.tableWidthInput?.value || "100";
            const cellPadding = contextDropdown.cellPaddingInput?.value || "5"
            const tableTabActive = contextDropdown.activeTab === 'table-settings';
            const cellTabActive = contextDropdown.activeTab === 'cell-settings';

            function getAlignmentValues(combo: string): { textAlign: string; verticalAlign: string } {
                const [vertical, horizontal] = combo.split('-');

                const verticalAlign = {
                    top: 'top',
                    middle: 'middle',
                    bottom: 'bottom'
                }[vertical] || 'top';

                const textAlign = {
                    left: 'left',
                    center: 'center',
                    right: 'right'
                }[horizontal] || 'left';

                return { textAlign, verticalAlign };
            }

            if (!selectedTable) {
                this.plugins.dialog.close.call(this);
                return;
            }

            if (selectedTable instanceof HTMLElement && selectedTable?.tagName === 'TABLE') {

                if (tableTabActive) {
                    selectedTable.setAttribute("style", `width: ${Math.min(100, Math.max(10, parseInt(tableWidth)))}% !important;`);

                    switch (selectedAlignment) {
                        case 'left':
                            selectedTable.style.marginLeft = '0';
                            selectedTable.style.marginRight = 'auto';
                            break;
                        case 'center':
                            selectedTable.style.marginLeft = 'auto';
                            selectedTable.style.marginRight = 'auto';
                            break;
                        case 'right':
                            selectedTable.style.marginLeft = 'auto';
                            selectedTable.style.marginRight = '0';
                            break;
                        default:
                            selectedTable.style.marginLeft = '';
                            selectedTable.style.marginRight = '';
                            break;
                    }

                    selectedTable.classList.toggle("se-table-no-border", tableBorderEnabled);

                    const cells = selectedTable.querySelectorAll("td, th");
                    cells.forEach((cell) => {
                        if (cell instanceof HTMLElement) {
                            const { textAlign, verticalAlign } = getAlignmentValues(selectedCellsAlignment);

                            cell.style.padding = `${Math.min(50, Math.max(0, parseInt(cellPadding)))}px`;
                            cell.style.verticalAlign = verticalAlign;
                            const innerDiv = cell.querySelector("div");
                            if (innerDiv && selectedCellsAlignment) {
                                if (innerDiv.hasAttribute('data-cell-align')) innerDiv.setAttribute('data-cell-align', selectedCellsAlignment);
                                innerDiv.setAttribute('data-align', selectedCellsAlignment);
                                innerDiv.style.textAlign = textAlign;
                            }
                        }
                    });
                }

                if (cellTabActive && selectedCell && (selectedCell?.tagName === "TD" || selectedCell?.tagName === "TH")) {
                    selectedCell.classList.toggle("se-cell-no-border", cellBorderEnabled);
                    const { textAlign, verticalAlign } = getAlignmentValues(selectedCellAlignment);
                    selectedCell.style.verticalAlign = verticalAlign;
                    const innerDiv = selectedCell.querySelector("div");
                    if (innerDiv) {
                        innerDiv.setAttribute('data-cell-align', selectedCellAlignment);
                        innerDiv.style.textAlign = textAlign;
                    }
                }
            }

            this.history.push(true);
            this.plugins.dialog.close.call(this);
        },
    };
}
